import type { PageContext } from "../chat/chat-view";

export type Remark = {
  /** What it is about; each topic comes up once per session. */
  topic: string;
  text: string;
};

export type RemarkOptions = {
  /** Quiet time after landing on a page before saying anything. */
  delayMs?: number;
  /** Least time between two remarks. */
  cooldownMs?: number;
  /** How long a dismissed remark keeps it quiet. */
  dismissedMs?: number;
  /** Reading pace for how long a remark stays up, plus a linger. */
  charsPerSecond?: number;
  lingerMs?: number;
  now?: () => number;
  setTimeout?: (fn: () => void, ms: number) => unknown;
  clearTimeout?: (handle: unknown) => void;
};

/**
 * What there is to say about `page`, by topic: only what a page published
 * (a seat with its program and rank, a running round). A page that said
 * nothing gets the host's stand-in context (no seat, no program), which is
 * a guess, so no seat alone is ever remarked on.
 */
export function remarksFor(page: PageContext | null): Remark[] {
  if (!page || page.seat !== "here") return [];

  const out: Remark[] = [];

  if (page.program)
    out.push({
      topic: `${page.coworld}:program:${page.program}:${page.rank ?? "-"}`,
      text: page.rank
        ? `${page.program} is ranked #${page.rank} here.`
        : `${page.program} plays here; it has no rank yet.`,
    });

  if (page.round && page.roundState === "running")
    out.push({
      topic: `${page.coworld}:round:${page.round}`,
      text: `Round ${page.round} is running now.`,
    });

  return out;
}
